<div class="custom-actions w100">
  <ng-container *ngIf="!loading">
    <div *ngIf="!showMenuAction; else menuAction" fxLayout="row" class="w100 actions">
      <ng-container *ngFor="let action of actions; let i = index">
        <div [ngSwitch]="action.type">
          <ng-container *ngSwitchCase="'separator'">
            <mat-divider vertical role="separator" style="display: inline"></mat-divider>
          </ng-container>

          <ng-container *ngSwitchCase="'custom'">
            <adf-dynamic-component *ngIf="action.data?.component; else adfComponent"
              [attr.id]="i + '-' + action.data.component + '-' + nodeEntry.entry.id" [data]="action.data"
              [id]="action.data.component"></adf-dynamic-component>
            <ng-template #adfComponent>
              <adf-dynamic-component *ngIf="action.component"
                [attr.id]="i + '-' + action.component + '-' + nodeEntry.entry.id" [data]="action.data"
                [id]="action.component" (pointerdown)="prepareSelection();" (click)="$event.stopPropagation();"></adf-dynamic-component>
            </ng-template>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <button mat-icon-button [title]="action.title | translate" (click)="handleAction(action);">
              <mat-icon *ngIf="!action.icon.includes(':'); else adfIcon">{{ action.icon }}</mat-icon>
              <ng-template #adfIcon>
                <adf-icon [value]="action.icon"></adf-icon>
              </ng-template>
            </button>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <ng-template #menuAction>
      <mat-icon [matMenuTriggerFor]="menu" class="w100" [title]="'APP.ACTIONS.MORE' | translate">
        more_vert
      </mat-icon>

      <mat-menu #menu="matMenu" class="menu">
        <div fxFlex fxLayout="column">
          <ng-container *ngFor="let action of actions; let i = index">
            <ng-container [ngSwitch]="action.type">
              <ng-container *ngSwitchCase="'separator'">
                <mat-divider role="separator"></mat-divider>
              </ng-container>

              <ng-container *ngSwitchCase="'custom'">
                <adf-dynamic-component *ngIf="action.component"
                  [attr.id]="i + '-' + action.component + '-' + nodeEntry.entry.id" [data]="action.data"
                  [id]="action.component"></adf-dynamic-component>
              </ng-container>

              <ng-container *ngSwitchDefault>
                <button class="context-button" mat-menu-item [title]="action.title | translate"
                  (click)="handleAction(action); $event.stopPropagation();">
                  <mat-icon class="adf-icon mat-icon" *ngIf="!action.icon.includes(':'); else adfIcon">{{
                    action.icon }}</mat-icon>
                  <ng-template #adfIcon>
                    <adf-icon class="adf-icon mat-icon" [value]="action.icon"></adf-icon>
                  </ng-template>
                  <span>{{ action.title | translate }}</span>
                </button>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </mat-menu>
    </ng-template>
  </ng-container>
</div>